import {createContext, useContext} from 'react';
import {DetailsFilterContextValue} from './suppliers.types';

const Context = createContext<DetailsFilterContextValue>([[], () => {}]);

export const useCompanyFilter = () => useContext(Context);
export default Context;
